{
    "a11y": {
        "closeDialog": "Fermer la boîte de dialogue",
        "closeImage": "Fermer l'affichage de l'image",
        "closePopup": "Fermer le point de carte",
        "closeSearch": "Fermer la recherche",
        "closeToc": "Fermer la table des matières",
        "cookieSettings": "Ouvrir les paramètres de confidentialité",
        "downloadSection": "Télécharger « {section} »",
        "enlargeImage": "Agrandir l'image",
        "imageViewer": "Affichage de l'image",
        "languageMenu": "Choisir la langue",
        "mainMenu": "Menu principal",
        "mapInstructions": "Utilisez les touches fléchées pour passer d'un point de carte à l'autre et Entrée ou Espace pour en ouvrir un. Plus et moins pour zoomer, 0 affiche toute la carte.",
        "mapRoleDescription": "Carte interactive",
        "menu": "Menu",
        "openSearch": "Ouvrir la recherche",
        "openToc": "Ouvrir la table des matières",
        "pointsList": "Points de carte",
        "share": "Partager cette carte",
        "shareVia": "Partager via {network}",
        "skipToPoints": "Aller aux points de carte",
        "unnamedPoint": "Point de carte sans titre",
        "videoPlayer": "Lecteur vidéo",
        "zoomIn": "Zoom avant",
        "zoomLevel": "Niveau de zoom {level}",
        "zoomLevelAnnounce": "Niveau de zoom {level}, {count} points de carte visibles",
        "zoomOut": "Zoom arrière",
        "zoomToFit": "Afficher toute la carte"
    },
    "editorial": {
        "close": "Fermer l'éditorial",
        "defaultTitle": "Note de la rédaction et équipe",
        "team": "Équipe"
    },
    "gallery": {
        "next": "Image suivante",
        "position": "Image {index} sur {total}",
        "previous": "Image précédente"
    },
    "back": "retour",
    "blockedMsg": "Les contenus externes sont bloqués par vos paramètres de confidentialité.",
    "changePrivacySettings": "Gérer les paramètres de confidentialité",
    "connections": "Connecté à :",
    "contentLastUpdate": "Dernière mise à jour :",
    "acceptAll": "Tout accepter",
    "acceptEssentialOnly": "Accepter uniquement les cookies essentiels",
    "imprint": "Mentions légales",
    "privacyPolicy": "Politique de confidentialité",
    "saveSettings": "Enregistrer les paramètres",
    "title": "Paramètres de confidentialité",
    "failed": "Le contenu n’a pas pu être chargé.",
    "loading": "Chargement du contenu…",
    "socialMedia": "Partager cet article :",
    "resetSearch": "Réinitialiser la recherche",
    "search": "Rechercher",
    "zoomLevels": "Niveaux de zoom",
    "previewNotice": "Ceci est un aperçu des dernières modifications, pas la vue en ligne de la carte."
}
